import { division, subtract } from "./Math";

const CalculationUtil = {

  apptapMargin: (reportedClickCost: string|number, revenuePublisher: string|number, revenueApptap: string|number): number => {
    const totalPayout = Number(reportedClickCost ?? 0) + Number(revenuePublisher ?? 0);
    const adjustedRevenue = Number(revenueApptap ?? 0);

    if ( adjustedRevenue === 0 ) {
      if ( totalPayout === 0 ) {
        return null;
      } else {
        return -1;
      }
    }

    // Publisher Margin (%) = (Publisher Revenue + Eff Cost Per Click / AppTap Revenue)
    // AppTap Margin (%) = (1 - Publisher Margin)
    const publisherMargin = totalPayout / adjustedRevenue;
    return 1 - publisherMargin;
  },
  untrackedClicksRate: (clicksReceived: string|number, clicksTracked: string|number): number => {
    const totalClicks =  subtract(clicksReceived, clicksTracked);
    if (totalClicks == null || clicksReceived == null) {
      return null;
    } else if (totalClicks === 0) {
      return 0;
    } else if (totalClicks > 0 && (clicksTracked == null || clicksTracked === 0)) {
      return 1;
    }

    // Untracked Clicks Rate (%) = (AppTap Clicks Received - Clicks Tracked) / (AppTap Clicks Received)
    return division(totalClicks, clicksReceived);
  }
}

export default CalculationUtil;